import axios from "axios";
import { API_URL } from "../Config";
import authHeader from "./auth-header";

const list = () => {
  return axios.get(API_URL + "setting", {
    headers: authHeader(),
  });
};
const update = (values) => {
  return axios.post(API_URL + "setting/update", values, {
    headers: {
      ...authHeader(),
      "Content-Type": "multipart/form-data", // Set multipart/form-data for file uploads
    },
  });
};
const web_detail = () => {
  return axios.get(API_URL + "detail", {
    headers: authHeader(),
  });
};
const settingService = { list, update, web_detail };

export default settingService;
